exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transfer-confirm__subject-field[data-v-2abd125e] {\n  padding-top: 0;\n}\n.withdrawal-cashbox__row[data-v-2abd125e],\n.withdrawal-daily-limit[data-v-2abd125e] {\n  color: rgba(191, 190, 190, 0.5);\n}\n.withdrawal-fees__label[data-v-2abd125e] {\n  margin-top: 12px;\n  color: #578AD6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2abd125e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/withdrawal/make/Withdrawal.Confirm.vue
// module id = X11K
// module chunks = 1